$(function() {
    $(document).ready(function() {
        if ($('.wheel-numbered')[0]) {
            const numberBtn = '.wheel-numbered__number';

            let animating = false;

            $('body').on('click', numberBtn, function() {
                var itemValue = $(this).data('item');
                var numberBtn = $('.wheel-numbered__content .wheel-numbered__item');
                var arrow = $('.wheel-numbered__circlular');
                var container = $(this)
                    .closest('.wheel-numbered')
                    .find('.wheel-numbered__content');

                $(arrow).removeClass(function(index, className) {
                    return (className.match(/(^|\s)active-\S+/g) || []).join(' ');
                });

                $(arrow).addClass('active-' + itemValue);

                if (!animating) {
                    if (!$(`.wheel-numbered__item[data-item='${itemValue}']`).hasClass('active')) {
                        animating = true;
                        $('.wheel-numbered__item.active').fadeOut(400, function() {
                            $(this).removeClass('active');
                            $(`.wheel-numbered__item[data-item='${itemValue}']`)
                                .fadeIn(400)
                                .addClass('active');
                            animating = false;
                        });
                        var itemTitle = $(`.wheel-numbered__item[data-item='${itemValue}']`).data('title');
                        var textTitle = $(`.wheel-numbered__item[data-item='${itemValue}']`)
                            .closest('.wheel-numbered')
                            .find('.wheel-numbered__activeTitle');
                        $(textTitle).fadeOut(400, function() {
                            $(this)
                                .text(itemTitle)
                                .fadeIn(400);
                        });
                    }
                }

                $('html, body').animate(
                    {
                        scrollTop: $(container).offset().top - 140,
                    },
                    1000
                );
            });
        }

        var $wheelNumbered = $('.wheel-numbered');

        $(window).resize(function() {
            if (window.innerWidth < 1101) {
                $('.wheel-numbered__content .wheel-numbered__item').removeAttr('style');
                $('.wheel-numbered__circlular').removeClass(function(index, className) {
                    return (className.match(/(^|\s)active-\d+/g) || []).join(' ');
                });
                $wheelNumbered
                    .find('.wheel-numbered__activeTitle')
                    .text($wheelNumbered.find('.wheel-numbered__item:first-child').data('title'));
            }
        });
    });
});
